import {RemotePostLoggingAccess} from 'data/usecases/private/my-hospitalization/remote-post-logging-access';
import {PostLoggingAccess} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makePostLoggingAccess = (): PostLoggingAccess =>
	new RemotePostLoggingAccess(
		makeBFFApiUrl(MyHospitalizationEndpoints.loggingAccess),
		makeAuthorizeHttpClientDecorator(),
	);
